module.exports = __webpack_public_path__ + "img/6.bea11bbe.jpg";